import enCommon from '../locales/en/common.json';
import enNav from '../locales/en/nav.json';
import enLibrary from '../locales/en/library.json';
import enPage from '../locales/en/page.json';
import enReview from '../locales/en/review.json';
import enShare from '../locales/en/share.json';
import enAi from '../locales/en/ai.json';
import enAuth from '../locales/en/auth.json';
import enSettings from '../locales/en/settings.json';
import enStats from '../locales/en/stats.json';

import jaCommon from '../locales/ja/common.json';
import jaNav from '../locales/ja/nav.json';
import jaLibrary from '../locales/ja/library.json';
import jaPage from '../locales/ja/page.json';
import jaReview from '../locales/ja/review.json';
import jaShare from '../locales/ja/share.json';
import jaAi from '../locales/ja/ai.json';
import jaAuth from '../locales/ja/auth.json';
import jaSettings from '../locales/ja/settings.json';
import jaStats from '../locales/ja/stats.json';

import koCommon from '../locales/ko/common.json';
import koNav from '../locales/ko/nav.json';
import koLibrary from '../locales/ko/library.json';
import koPage from '../locales/ko/page.json';
import koReview from '../locales/ko/review.json';
import koShare from '../locales/ko/share.json';
import koAi from '../locales/ko/ai.json';
import koAuth from '../locales/ko/auth.json';
import koSettings from '../locales/ko/settings.json';
import koStats from '../locales/ko/stats.json';

export const namespaces = [
  'common',
  'nav',
  'library',
  'page',
  'review',
  'share',
  'ai',
  'auth',
  'settings',
  'stats',
] as const;
export type Namespace = (typeof namespaces)[number];

export const resources = {
  en: {
    common: enCommon,
    nav: enNav,
    library: enLibrary,
    page: enPage,
    review: enReview,
    share: enShare,
    ai: enAi,
    auth: enAuth,
    settings: enSettings,
    stats: enStats,
  },
  ja: {
    common: jaCommon,
    nav: jaNav,
    library: jaLibrary,
    page: jaPage,
    review: jaReview,
    share: jaShare,
    ai: jaAi,
    auth: jaAuth,
    settings: jaSettings,
    stats: jaStats,
  },
  ko: {
    common: koCommon,
    nav: koNav,
    library: koLibrary,
    page: koPage,
    review: koReview,
    share: koShare,
    ai: koAi,
    auth: koAuth,
    settings: koSettings,
    stats: koStats,
  },
} as const;

export type SupportedLocale = keyof typeof resources;

export const locales: { code: SupportedLocale; label: string; nativeLabel: string }[] = [
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'ja', label: 'Japanese', nativeLabel: '日本語' },
  { code: 'ko', label: 'Korean', nativeLabel: '한국어' },
];
